export default {"src":"/_next/static/media/traditional-360-icon.a4191905.svg","height":139,"width":138,"blurWidth":0,"blurHeight":0};